import TermCreateEdit from "../AdminTermCreateEdit";

export default class AdminTermCreateEditPlaceOfService extends TermCreateEdit {
  /**
   * @returns {string} The term type.
   */
  getType() {
    return "place_of_service";
  }
}
